import React, { useEffect, useRef, useState } from 'react';

import * as styles from './Tags.module.scss';

const AVG_SYMBOL_WIDTH = 8;
const TAG_INDENT = 36;

export default function Tags({ tags }) {
  const tagsContainerRef = useRef(null);
  const buttonTagRef = useRef(null);

  const [visibleTags, setVisibleTags] = useState([]);
  const [hiddenTags, setHiddenTags] = useState([]);

  const updateTags = () => {
    if (tags?.length) {
      setVisibleTags([]);
      setHiddenTags([]);

      const tagsContainerWidth = tagsContainerRef.current?.clientWidth - 28;
      const buttonTagWidth = buttonTagRef.current?.clientWidth ?? 0;
      let totalWidth = 0;

      const tagsToShow = [];
      const tagsToHide = [];

      tags.forEach(tag => {
        const trimmedTags = tag.trim();
        const currentWidth = trimmedTags.length * AVG_SYMBOL_WIDTH + TAG_INDENT;
        const tagWidth = totalWidth + currentWidth + buttonTagWidth;

        if (tagWidth < tagsContainerWidth) {
          totalWidth += currentWidth;
          tagsToShow.push(trimmedTags);
        } else {
          tagsToHide.push(trimmedTags);
        }
      });

      setVisibleTags(tagsToShow);
      setHiddenTags(tagsToHide);
    }
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      updateTags();
    });

    if (tagsContainerRef.current) {
      resizeObserver.observe(tagsContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [tags]);

  return (
    <div ref={tagsContainerRef} className={styles.container}>
      {visibleTags.map(tag => (
        <div key={tag} className={styles.tag}>
          {tag}
        </div>
      ))}
      {hiddenTags.length > 0 && (
        <div className={styles.hiddenTags}>
          <div className={styles.tooltip}>
            {hiddenTags.map((tag, i) => (hiddenTags.length === i + 1 ? tag : tag + ', '))}
          </div>
          <div ref={buttonTagRef} className={styles.tag}>
            +{hiddenTags.length}
          </div>
        </div>
      )}
    </div>
  );
}
